import $ from "jquery";
import {
  LabeledComponentDefinition,
  ValueComponent,
  ValueComponentDefinition,
} from "../components/Component";
import template from "./image.hbs";
import "./image.scss";
import appModuleRegistry from "../appModules/appModuleRegistry";

export class ImageInput implements ValueComponent {
  public componentType = "image";
  public id: string;
  public definition: ImageInputDefinition;
  public view: Element;

  constructor(schema: ImageInputDefinition) {
    this.definition = schema;
    if (schema.labelKey == null || schema.labelKey.length === 0) {
      this.definition.labelWidth = 0;
    }
    if (this.definition.emptyWidth == null) {
      this.definition.emptyWidth = 0;
    }
    if (this.definition.inputWidth == null) {
      this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
    }
  }

  public render(): Element {
    this.renderTemplate();
    return this.view;
  }

  public renderTemplate(): Element {
    const jqueryView = $(
      template(
        Object.assign(this.definition, {
          _inputWidth: 1 * this.definition.maxlength + 3
        })
      ),
    );
    this.view = jqueryView[0];
    return this.view;
  }

  public getValue(): string {
    const v = this.view
      .querySelector("img")
      .getAttribute("src") as string;
    if (v === "") {
      return null;
    } else {
      return v;
    }
  }

  public value(v: string): void {
    let url;
    if (v != null) {
      url = appModuleRegistry.prefixUrl(v);
    } else {
      url = null;
    }
    this.view
      .querySelector("img")
      .setAttribute("src", url);
  }
}

export interface ImageInputDefinition
  extends LabeledComponentDefinition,
  ValueComponentDefinition {
  inputWidth?: number;
  emptyWidth?: number;
  maxlength?: number;
}